import type { BezoekersbestandEntry, Contact } from "@domaddress/shared";

/** Map dominicusganger-rij naar Contact voor zend-contacten / vCard. */
export function bezoekerEntryToContact(b: BezoekersbestandEntry): Contact {
  return {
    id: b.id,
    first_name: b.first_name,
    last_name: b.last_name,
    tussenvoegsel: b.tussenvoegsel,
    email: b.email,
    email_prive: b.email,
    email_werk: b.email_secondary,
    dominicus_email: b.dominicus_email ?? undefined,
    phone: b.phone,
    phone_mobile: b.phone_secondary,
    entity_kind: "dominicusganger",
    wants_newsletter: b.wants_newsletter,
    wants_activities_info: b.wants_activities_info,
    willing_volunteer: b.willing_volunteer,
    created_by: 0,
    created_at: "",
    updated_at: "",
  };
}
